import React, { useState } from "react";
import { Arrow, Pin, Book } from "@images/icons";
import { twMerge } from "tailwind-merge";

interface PrimarySubmitButtonProps {
  externalText: string;
  internalText: string;
  icon?: PrimarySubmitButtonIcon;
  width?: number;
  onClick?: () => void;
  className?: string;
}

// Controls the options for the PrimarySubmitButton icon
export type PrimarySubmitButtonIcon = "arrow" | "book" | "pin";

const PrimarySubmitButton = ({
  width = 260,
  icon = "arrow",
  className,
  onClick,
  ...props
}: PrimarySubmitButtonProps) => {
  // Initializing state for slide animation on hover
  const [isShown, setIsShown] = useState(false);

  // Assigning Icon based on passed prop
  let Icon;
  switch (icon) {
    case "pin":
      Icon = Pin;
      break;
    case "book":
      Icon = Book;
      break;
    default:
      Icon = Arrow;
  }
  return (
    <button
      onClick={onClick}
      type="submit"
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
      style={{ width: width }}
      className={twMerge(
        "relative flex h-[50px] cursor-pointer items-center justify-center overflow-hidden rounded-full bg-redWood font-heading text-2xl tracking-[1.44px] text-offWhite shadow-[2px_2px_4px_#5D5054CC]",
        className
      )}
    >
      <div
        className={`absolute z-[2] flex h-full w-full items-center justify-center bg-lightPink transition-all duration-150 ${
          isShown && "translate-x-full"
        }`}
      >
        <div
          className={`absolute left-0 z-[4] flex h-[50px] w-[50px] items-center justify-center rounded-full bg-salmon text-redWood ${
            isShown && "-translate-x-full"
          }`}
        >
          <Icon className="w-[33px] fill-redWood" />
        </div>
        <span className="ml-[10%] text-redWood">{props.externalText}</span>
      </div>
      <span className="-ml-[10%]">{props.internalText}</span>
    </button>
  );
};

export default PrimarySubmitButton;
